// extracted by mini-css-extract-plugin
module.exports = {"pagination_ui":"Pagination_pagination_ui__xhHgt","button":"Pagination_button__vjQp_","control":"Pagination_control__keUBw","active":"Pagination_active__3aAn0"};